import { useParams, Link, useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { getProject } from '../api/projects'
import { getElectricalPanelById } from '../api/electricalPanels'
import CableInstances from './CableInstances'

export default function CableInstancesPage() {
  const { projectId, panelId } = useParams<{ projectId: string; panelId?: string }>()
  const [searchParams] = useSearchParams()
  const specificationId = searchParams.get('spec') ? Number(searchParams.get('spec')) : undefined
  
  // If specificationId is provided, panelId is not required
  const isSpecificationFilter = !!specificationId

  const { data: project, isLoading: projectLoading } = useQuery({
    queryKey: ['project', projectId],
    queryFn: () => getProject(Number(projectId)),
    enabled: !!projectId,
  })

  const { data: panel } = useQuery({
    queryKey: ['electricalPanel', panelId],
    queryFn: () => getElectricalPanelById(Number(panelId!)),
    enabled: !!panelId && !isSpecificationFilter,
  })

  if (projectLoading) {
    return <div className="text-center py-8">Загрузка проекта...</div>
  }

  if (!project) {
    return <div className="text-center py-8 text-red-600">Проект не найден</div>
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <Link to={`/projects/${projectId}`} className="text-blue-600 hover:text-blue-800 mb-2 inline-block">
            ← Назад к {project.name}
          </Link>
          {specificationId && (
            <Link 
              to={panelId ? `/projects/${projectId}/panels/${panelId}/cable-instances` : `/projects/${projectId}/cable-instances`} 
              className="text-red-600 hover:text-red-800 mb-2 ml-4 inline-block"
            >
              ✕ Сбросить фильтр
            </Link>
          )}
          <h1 className="text-3xl font-bold text-gray-900">
            🔌 Экземпляры кабелей
            {isSpecificationFilter ? (
              <span className="text-lg font-normal text-blue-600 ml-2">
                → Спецификация ID: {specificationId}
              </span>
            ) : (
              panel && (
                <span className="text-lg font-normal text-gray-600 ml-2">
                  → {panel.proj_id} ({panel.name})
                </span>
              )
            )}
          </h1>
          <p className="text-gray-600 mt-1">
            {isSpecificationFilter 
              ? `Просмотр всех экземпляров кабелей спецификации ID: ${specificationId} в проекте`
              : panel 
                ? `Создание и управление экземплярами кабелей щита ${panel.proj_id}` 
                : 'Создание и управление конкретными экземплярами кабелей для проекта'
            }
          </p>
        </div>
      </div>

      {/* Cable Instances Component */}
      <CableInstances 
        projectId={Number(projectId!)} 
        electricalPanelId={isSpecificationFilter ? undefined : (panelId ? Number(panelId) : undefined)}
        specificationId={specificationId}
      />
    </div>
  )
} 